import { Image } from '@heroui/react';
import React, { FC, useEffect, useState } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { countryFlagHelper } from 'src/config';

import { FlagWrapper } from './TranslationSwitcher.styled';

interface TranslationSwitcher {
    languages: string[];
    currentLang: string;
    onSelectedLangChange?: (lang: string) => void;
}
export const TranslationSwitcher: FC<TranslationSwitcher> = ({
  languages,
  onSelectedLangChange,
  currentLang,
}) => {
  const [selectedLang, setSelectedLang] = useState<string>();
  const handleLanguageChange = (lang: string) : void => {
    if (onSelectedLangChange) {
      onSelectedLangChange(lang);
    }
    setSelectedLang(lang);
  };

  useEffect(() => {
    setSelectedLang(currentLang);
  }, [currentLang]);

  return (
    <div className="flex items-center gap-1 pb-1">
      {(languages || []).map((lang) => {
        const flag = countryFlagHelper(lang);
        return (
          <FlagWrapper key={lang} isActive={lang === selectedLang}>
            {flag.type === 'iso' ? (
              <ReactCountryFlag
                key={lang}
                countryCode={lang === 'en' ? 'gb' : lang}
                onClick={() => handleLanguageChange(lang)}
                svg
                style={{
                  cursor: 'pointer',
                  width: 18,
                  height: 14,
                  background: '#fff',
                  borderRadius: '2px',
                }}
              />
            ) : (
              <Image
                classNames={{ wrapper: 'mr-2 inline-block' }}
                key={lang}
                src={flag.value}
                onClick={() => handleLanguageChange(lang)}
                alt={lang}
                width={18}
                height={14}
              />
            )}
          </FlagWrapper>
        );
      })}
    </div>

  );
};
